module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-active.2efe1095.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/primary-active.png
// module id = 3064
// module chunks = 11